import axios from '@axios'

import JwtService from './jwtService'

const overrideConfig = {
  loginEndpoint: '/api/v1/jwt/create/',
  refreshEndpoint: '/api/v1/jwt/refresh/',
  tokenType: 'JWT',
}
export default new JwtService(axios, overrideConfig)
